export const OB_SANDBOX_RESELLER_ID = "999999998";
export const OB_SANDBOX_HOST = "rc-sandbox.webpropanel.com";

export function isObSandbox(
  resellerId: string | number | undefined,
  hostname: string | null | undefined
) {
  return (
    String(resellerId) === OB_SANDBOX_RESELLER_ID &&
    hostname === OB_SANDBOX_HOST
  );
}

export function oboxApiPrefix(isSandbox: boolean) {
  return isSandbox ? "obox/sandbox/" : "obox/";
}
